import React from "react";
import { useForm } from "react-hook-form";

export const Step7PaymentForm = ({
  loginText = "Log in",
  isDebug = false,
  pricingLink = "#",
  isPromo = false,
  cardDetails,
  ccMonths = [],
  ccYears = [],
  hideSkipPaymentBtn = false,
  goToStep,
  upgradeUser,
}) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    watch,
  } = useForm({
    defaultValues: cardDetails || {
      CardName: "",
      CardNumber: "",
      ExpiryMM: "01",
      ExpiryYY: new Date().getFullYear().toString().slice(-2),
      CVV: "",
      PriceAfterCoupon: 0,
    },
  });

  const onSubmit = (data) => {
    upgradeUser(data);
  };

  const isCardDisabled = Boolean(cardDetails?.chargifySubscriptionId);
  const priceAfterCoupon = watch("PriceAfterCoupon");

  return (
    <div className="step7">
      <div className="font-22 t-c font-circular-std-bold">Upgrade Today</div>

      {cardDetails?.ChargifyPlusProduct && (
        <div className="packages-holder mb-4">
          {/* Replace with appropriate rendering logic */}
          <ChargifyProductSummary product={cardDetails.ChargifyPlusProduct} />
        </div>
      )}

      <form
        className="join-form-inline form-is-custom form-disable-pristine-error"
        onSubmit={handleSubmit(onSubmit)}
        noValidate
      >
        <input type="hidden" {...register("PriceAfterCoupon")} />
        <div className="d-flex justify-content-between pb-2">
          <div className="font-15">
            <span className="font-circular-std-bold">Card Details</span>{" "}
            {isCardDisabled && (
              <a href="/my-account/payments">
                Edit <i className="fa is-edit"></i>
              </a>
            )}
          </div>
        </div>

        {priceAfterCoupon !== 0 && (
          <div className="row">
            <div className="col-md-12">
              <div
                className={`form-group mb-2 ${
                  errors.CardName ? "xhas-error" : ""
                }`}
              >
                <input
                  className="form-control l-h-1"
                  type="text"
                  placeholder="Name on card"
                  disabled={isCardDisabled}
                  {...register("CardName", {
                    required: !isCardDisabled && "Name on card is required.",
                  })}
                />
              </div>
            </div>

            <div className="col-md-12">
              <div
                className={`form-group mb-2 ${
                  errors.CardNumber ? "xhas-error" : ""
                }`}
              >
                <input
                  className="form-control l-h-1"
                  type="text"
                  placeholder="Card number"
                  disabled={isCardDisabled}
                  {...register("CardNumber", {
                    required: !isCardDisabled && "Card number is required.",
                  })}
                />
              </div>
            </div>
          </div>
        )}

        <div className="row row-sm">
          <div className="col-6 col-xs-6 col-sm col-sm-4 col-md-4">
            <select
              className="form-control fw"
              disabled={isCardDisabled}
              {...register("ExpiryMM")}
            >
              {ccMonths.map((month) => (
                <option key={month.Value} value={month.Value}>
                  {month.Text}
                </option>
              ))}
            </select>
          </div>
          <div className="col-6 col-xs-6 col-sm col-sm-4 col-md-4">
            <select
              className="form-control fw"
              disabled={isCardDisabled}
              {...register("ExpiryYY")}
            >
              {ccYears.map((year) => (
                <option key={year.Value} value={year.Value}>
                  {year.Text}
                </option>
              ))}
            </select>
          </div>
          <div className="col-6 col-xs-6 col-sm col-sm-4 col-md-4 mt-2 mt-sm-0">
            <div
              className={`form-group ${errors.CVV ? "xhas-error" : ""}`}
            >
              <input
                className="form-control l-h-1"
                type="text"
                placeholder="CVV"
                disabled={isCardDisabled}
                {...register("CVV", {
                  required: !isCardDisabled && "CVV is required.",
                })}
              />
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-md-12 mt-2">
            <div className="row row-sm">
              <div className="col col-xs-12 col-sm">
                {priceAfterCoupon !== 0 ? (
                  <button
                    className="btn btn-primary btn-fw btn-brand-style-with-pad-sm mt-0 mb-4 font-15-no-line-height"
                    type="submit"
                  >
                    Make payment
                  </button>
                ) : (
                  <button
                    className="btn btn-primary btn-fw btn-brand-style-with-pad-sm mt-0 font-15-no-line-height"
                    type="submit"
                  >
                    Proceed
                  </button>
                )}
              </div>
            </div>
          </div>

          {!isPromo && !hideSkipPaymentBtn && (
            <div className="col-md-12 mt-2">
              <div className="row row-sm">
                <div className="col col-xs-12 col-sm">
                  <button
                    className="btn btn-primary btn-fw btn-brand-style-with-pad-sm font-15-no-line-height"
                    type="button"
                    onClick={() => goToStep("Step4MobileUpdate")}
                  >
                    Maybe later
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      </form>

      {!isPromo && (
        <div className="font-15 t-c hidden-sm-down">
          Compare our{" "}
          <a href={pricingLink} className="text-underline text-color-brand-green">
            membership packages.
          </a>
        </div>
      )}
    </div>
  );
};

